<template>
  <div>
    <Page
      title="バックグランド処理状況"
      helpInfoTitle="アセスメントサーベイグループでサーベイの目的と受検期間を設定し、グループの詳細から受検者を追加できます"
    >
      <template v-slot:content>
        <div class="uk-card uk-card-default uk-card-body">
          <Table :header="header" :tableData="queueManages" @column-click="onColumnClick" />
        </div>
      </template>
    </Page>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
@include modal-form;
.action .action-button:first-child {
  margin-right: $spacing-medium;
}
.search-field {
  margin-right: $spacing-medium;
}
.uk-modal-dialog {
  width: unset;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import Page from "@/components/molecules/Page.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import Table from "@/components/molecules/Table.vue";
import { ClientApi, GetQueueManageItem, QueueManageTypeEnum } from "../../autogen";
import { InstructionLevel } from "../../types";
import SearchField from "../atoms/SearchField.vue";
import moment from "moment-timezone";
import Store from "../../store";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    SearchField
  }
})
export default class QueueManage extends Vue {
  @Ref("monthly-report")
  monthlyReport!: HTMLElement;
  @Ref("editor")
  editor!: HTMLElement;
  query = "";
  queueManages: (GetQueueManageItem & {
    typeName: string;
    statusName: string;
  })[] = [];
  queueManage?: GetQueueManageItem;
  header = [
    { title: "ファイル名", sortable: true, key: "filename", width: 150 },
    { title: "種別", sortable: true, key: "typeName", width: "expand" },
    { title: "アップロード日時", key: "uploadDateTime", width: "expand" },
    { title: "作成者", key: "uploadBy", width: 150 },
    { title: "ステータス", key: "statusName", width: 110 },
    {
      title: "エラー内容",
      key: "error",
      width: 150,
      type: "button",
      render: (row: GetQueueManageItem) => (row.errors ? "button" : "")
    }
  ];
  filterColumns = ["filename", "type", "uploadDateTime"];
  editorFormKey = 0;
  private readonly authStore = Store.getInstance();
  async loadData() {
    const statusLabels: { id: string; name: string }[] = [
      { id: "0", name: "処理前" },
      { id: "10", name: "処理中" },
      { id: "20", name: "処理完了" },
      { id: "90", name: "処理失敗" }
    ];
    const response = await new ClientApi().getQueueManage({ q: this.query });
    this.queueManages = response.data.map(d =>
      Object.assign(d, {
        typeName: d.type === QueueManageTypeEnum.EmployeeExcel ? "従業員Excel登録" : "応募者Excel登録",
        uploadDateTime: `${moment(d.uploadDateTime).format("YYYY/MM/DD HH:mm:ss")}`,
        statusName: statusLabels.find(e => e.id === d.status)!.name
      })
    );
    this.queueManages.sort(function(a: any, b: any) {
      if (a.uploadDateTime !== b.uploadDateTime) {
        return a.uploadDateTime < b.uploadDateTime ? 1 : -1;
      }
      return 0;
    });
  }
  async beforeMount() {
    await this.loadData();
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "error") {
      const queueManage = this.queueManages[location.row];
      const mess = "ファイル名: " + queueManage.filename + "\n\n" + queueManage.errors!.join("\n");
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, mess);
    }
  }
}
</script>
